import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { createPageUrl } from 'utils';
import { Button } from 'Components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';

const features = [
    'Oltre 20 anni di esperienza',
    'Operativi in tutta la Sicilia',
    'Intervento entro 24h',

    'Ricambi originali garantiti',
    'Assistenza post-vendita',
];

export default function AboutSection() {
    return (
        <section className="py-24 bg-gray-50 overflow-x-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        className="relative"
                    >
                        <div className="aspect-square rounded-3xl overflow-hidden">
                            <img
                                src="/images/about-technician.jpg"
                                alt="Tecnico UPS"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        {/* Floating Card */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.3 }}
                            className="absolute bottom-4 right-4 bg-white rounded-2xl shadow-2xl p-6 max-w-xs"
                        >
                            <div className="flex items-center gap-4">
                                <div className="w-16 h-16 rounded-2xl bg-blue-600 flex items-center justify-center">
                                    <span className="text-2xl font-bold text-white">20+</span>
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-900">Anni di esperienza</p>
                                    <p className="text-sm text-gray-500">Nel settore UPS</p>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>

                    {/* Content */}
                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <span className="text-sm font-medium text-blue-600 uppercase tracking-wider">Chi siamo</span>
                        <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">
                            Il partner di fiducia per la continuità energetica
                        </h2>
                        <p className="mt-6 text-lg text-gray-600 leading-relaxed">
                            Tecnosys è la scelta di fiducia per UPS professionali in Sicilia. Supportiamo ospedali, cliniche, aeroporti, supermercati, farmacie e laboratori, riducendo i tempi di fermo e garantendo continuità operativa.
                        </p>
                        <p className="mt-4 text-gray-600 leading-relaxed">
                            Con precisione, rapidità e trasparenza, offriamo vendita, assistenza e riparazione di gruppi di continuità dei principali marchi del settore, tra cui Riello UPS, AEC UPS, APC, Tecnoware e Atlantis, per clienti critici in tutta la regione.
                        </p>

                        {/* Features Grid */}
                        <div className="mt-8 grid grid-cols-2 gap-4">
                            {features.map((feature) => (
                                <div key={feature} className="flex items-center gap-2">
                                    <CheckCircle className="w-5 h-5 text-blue-600 shrink-0" />
                                    <span className="text-sm text-gray-700">{feature}</span>
                                </div>
                            ))}
                        </div>

                        <div className="mt-10">
                            <Link to={createPageUrl('Contatti')}>
                                <Button size="lg" className="rounded-full bg-blue-600 hover:bg-blue-700 gap-2 text-white">
                                    Contattaci ora
                                    <ArrowRight className="w-5 h-5" />
                                </Button>
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}